import { gql } from '@apollo/client';

export const CHECK_CLIENT = gql`
  mutation checkClient($email: String!, $captcha: String!) {
    checkClient(email: $email, captcha: $captcha) {
      validCaptcha
      codeCreatedAt
    }
  }
`;
